export default {
  getItem (key, hash) {
    if (key) {
      let value = ''

      try {
        value = localStorage.getItem(key)

        if (value) {
          const data = JSON.parse(value)

          if (data) {
            if (data.expired && data.expired - 0 <= new Date().getTime()) {
              this.removeItem(key)
              return ''
            }

            if (hash && data._hash !== hash) {
              this.removeItem(key)
              return ''
            }

            return data.data || data
          }
        }
      } catch (err) {
        return value
      }
    }
  },
  setItem (key, value, expired, hash) {
    // 支持hash,expired两者其一或全部
    const obj = {
      data: value
    }

    if (expired) {
      obj.expired = new Date().getTime() + expired
    }
    if (hash) {
      obj._hash = hash
    }

    localStorage.setItem(key, JSON.stringify(obj))
  },
  removeItem (key) {
    if (key) {
      localStorage.removeItem(key)
    }
  }
}
